// extracted by mini-css-extract-plugin
export default {"container":"WrappingTwoColumnLayout-module__container--KGsSM","left":"WrappingTwoColumnLayout-module__left--XzfP0","right":"WrappingTwoColumnLayout-module__right--qEbkE"};